var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarGradientIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.632 28.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e87f3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_154",
    "data-name": "Trac\\xE9 154",
    d: "M16.316,2a2.863,2.863,0,0,1,2.493,1.455l3.486,6.169L28.318,10.8a2.863,2.863,0,0,1,1.43,4.878l-4.581,4.387,1.06,7.289A2.863,2.863,0,0,1,22.1,30.324L16.316,27.4,10.53,30.324A2.863,2.863,0,0,1,6.4,27.356l1.06-7.289L2.883,15.68A2.863,2.863,0,0,1,4.314,10.8l6.023-1.178,3.486-6.169A2.863,2.863,0,0,1,16.316,2ZM12.181,12.181,4.863,13.612l5.647,5.407L9.238,27.768l7.078-3.579,7.078,3.579-1.272-8.749,5.647-5.407-7.318-1.432L16.316,4.863Z",
    transform: "translate(-2 -2)",
    fillRule: "evenodd",
    fill: "url(#gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGradientIcon);
export default __webpack_public_path__ + "static/media/StarGradientIcon.0037deb8036510b7f5d93181549398ea.svg";
export { ForwardRef as ReactComponent };